module.exports = __webpack_public_path__ + "static/img/ARAD-S4_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD-S4_1.png
// module id = ykAI
// module chunks = 0